import useVehicleSingleSchema from '/business/shared/components/questions/sharedQuestions/_hooks/useVehicleSingleSchema';
import type { QuestionTreeItem } from '/business/shared/functions/types';
import type { VehicleFuelTypeOption } from '/business/shared/state/selectors/application/step1/getFuelTypesSelector';
import type { VehicleSizeOption } from '/business/shared/state/selectors/application/step1/getVehicleSizesSelector';

type VehicleSizesFactory = (fuelType: string | null) => VehicleSizeOption[];

interface TransportationAndDistributionSchemaOptions {
  applicationId?: number | string | null;
  businessName?: string | null;
  dealershipName?: string | null;
  displayLesseeField?: boolean;
  displayNumOfVehicles?: boolean;
  freeTypeDistance?: boolean;
  fuelTypes: VehicleFuelTypeOption[];
  isTotalFuelConsumptionComplete?: boolean;
  question: QuestionTreeItem;
  vehicleSizesFactory?: VehicleSizesFactory | null;
}

export default function useGetTransportationAndDistributionSchema({
  fuelTypes,
  question,
  freeTypeDistance,
  dealershipName,
  applicationId,
  businessName,
  vehicleSizesFactory,
  displayNumOfVehicles,
  isTotalFuelConsumptionComplete,
  displayLesseeField,
}: TransportationAndDistributionSchemaOptions) {
  return useVehicleSingleSchema({
    fuelTypes,
    vehicleSizesFactory,
    freeTypeDistance,
    displayLesseeField,
    applicationId,
    businessName,
    dealershipName,
    question,
    isTotalFuelConsumptionComplete,
    displayNumOfVehicles,
    prependTransportAndDistribText: true,
    useSlugForSizeDropdown: false,
  });
}
